<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
    <span>位置：</span>
    <ul class="placeul">
    <li><a href="#">首页</a></li>
    <li><a href="#">短信</a></li>
    <li><a href="#">草稿箱</a></li>
    </ul>
    </div>
    
    
    <div id="usual1" class="usual"> 
 
  	<div class="formbody">
    
    <table class="tablelist">
    	<thead>
    	<tr>
            <th>订单号</th>
            <th>充值时间</th>
            <th>充值号码</th>
            <th>流量包大小</th>
            <th>费用</th>
            <th>状态</th>
            <th>操作</th>
        </tr>
        </thead>
        <tbody>
        
        <tr v-for="(item,index) in rechargeReqList" :class="{odd:index%2!=0}">
            <td>{{item.srcNo}}</td>
            <td>{{item.c_Time}}</td>
            <td>{{item.destPhone}}</td>
            <td>{{item.packageSize}}</td>
            <td>{{item.totalFee}}</td>
            <td><ol v-if="item.isState==0">未处理</ol><ol v-else-if="item.isState == 1">已处理</ol><ol v-else>未知</ol></td>
            <td><ol v-if="item.stat==0"><a href="#" @click="rechargedetail(item.midNo)" class="tablelink">充值明细</a> </ol><ol v-else>--</ol></td>
        </tr>
        </tbody>
    </table>
    <div class="pagin">
    	<el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[50]"
            :page-size="50"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
    
    
    <div class="jian">&nbsp;</div>
  
    </div> 
    
    
  	
    </div> 
    
    <!-- 查询等待 -->
    <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
    top: 0; left: 0;display: block;" v-show="loadingShow"></div>
    <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
    -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
    <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
    <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
    </div>

    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobile:'',
            rechargeReqList:[],
            lldx:'',
            pageIndex:0,
            totalCount:0,
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            var that = this
            let data = {'pageIndex':pageIndex,'pageSize':50}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/llrecharge/llrechargelog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.rechargeReqList = res.data.rechargeReqList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        rechargedetail(midNo){
            // console.log(midNo);
            location.href = "/llrechargedetail?midNo=" + midNo;
        }
    }
    
}
</script>



// WEBPACK FOOTER //
// src/components/liuliang/llrechargelog.vue